exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".not-found-container[data-v-34557fda]{display:flex;justify-content:center;align-items:center;flex-direction:column;margin:auto;padding:4rem 0;width:50%}.not-found-container .emoji-oops[data-v-34557fda]{font-size:4rem}.not-found-container p[data-v-34557fda]{font-size:2rem}.not-found-container .message[data-v-34557fda]{padding:1em;background-color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-34557fda","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NotFound.vue
// module id = uwoe
// module chunks = 18